import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Users, Star, Heart } from 'lucide-react';
export function AboutPage() {
  return <main className="pt-20 pb-20" data-id="element-303">
      <div className="bg-gray-50 py-16 mb-12" data-id="element-304">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-305">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-306">
            About Limitless Taekwondo
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-307">
            More than just a martial arts school—we are a family dedicated to
            empowering our community.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-308">
        {/* Mission Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-20" data-id="element-309">
          <div data-id="element-310">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-311">
              Our Philosophy
            </h2>
            <p className="text-gray-600 mb-4 leading-relaxed" data-id="element-312">
              At Limitless Taekwondo, we believe that martial arts training is a
              vehicle for personal growth. Our goal is not just to teach
              self-defense, but to instill the values of respect, discipline,
              and perseverance in every student.
            </p>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-313">
              As a female-led school, we bring a unique perspective to martial
              arts training—one that balances discipline with nurturing support.
              We understand that every student learns differently, and we are
              committed to helping each individual reach their full potential.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8" data-id="element-314">
              <div className="text-center p-4 bg-blue-50 rounded-lg" data-id="element-315">
                <Users className="w-8 h-8 text-primary mx-auto mb-2" data-id="element-316" />
                <h3 className="font-semibold" data-id="element-317">Community</h3>
              </div>
              <div className="text-center p-4 bg-orange-50 rounded-lg" data-id="element-318">
                <Star className="w-8 h-8 text-accent mx-auto mb-2" data-id="element-319" />
                <h3 className="font-semibold" data-id="element-320">Excellence</h3>
              </div>
              <div className="text-center p-4 bg-purple-50 rounded-lg" data-id="element-321">
                <Heart className="w-8 h-8 text-purple-600 mx-auto mb-2" data-id="element-322" />
                <h3 className="font-semibold" data-id="element-323">Passion</h3>
              </div>
            </div>
          </div>
          <div className="relative" data-id="element-324">
            <div className="absolute inset-0 bg-primary/10 rounded-2xl transform rotate-3" data-id="element-325"></div>
            <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Instructor teaching class" className="relative rounded-2xl shadow-lg w-full object-cover h-[500px]" data-id="element-326" />
          </div>
        </div>

        {/* Leadership Section */}
        <div className="mb-20" data-id="element-327">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-328">
            Meet Our Leadership
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-329">
            {[1, 2, 3].map(i => <Card key={i} className="text-center p-6" data-id="element-330">
                <div className="w-32 h-32 mx-auto mb-6 rounded-full overflow-hidden border-4 border-white shadow-md" data-id="element-331">
                  <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=instructor${i}&gender=female`} alt="Instructor" className="w-full h-full object-cover" data-id="element-332" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-333">
                  Master Instructor
                </h3>
                <p className="text-primary font-medium mb-4" data-id="element-334">
                  4th Degree Black Belt
                </p>
                <p className="text-gray-600 text-sm" data-id="element-335">
                  Dedicated to helping students achieve their goals through
                  positive reinforcement and expert instruction.
                </p>
              </Card>)}
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-primary rounded-2xl p-8 md:p-12 text-center text-white" data-id="element-336">
          <h2 className="text-3xl font-bold mb-4" data-id="element-337">Experience the Difference</h2>
          <p className="text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-338">
            Come see why families in Brighton choose Limitless Taekwondo. We
            invite you to visit our school, meet our instructors, and try a
            class.
          </p>
          <Link to="/trial" data-id="element-339">
            <Button size="lg" className="bg-accent hover:bg-accent-dark text-white border-none" data-id="element-340">
              Start Your 4-Week Trial
            </Button>
          </Link>
        </div>
      </div>
    </main>;
}